<template>
  <div id="customer">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-input id="maininput" placeholder="请输入客户名称" prefix-icon="el-icon-search" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="doSelect" v-if="roles.indexOf('4')>-1">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addFormVisible = true" v-if="roles.indexOf('1')>-1">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
      </el-pagination>
    </el-col>

    <!-- 列表 -->
    <el-table :data="infos" border style="width: 100%" v-loading="listLoading">
      <el-table-column prop="name" label="客户">
      </el-table-column>
      <el-table-column prop="phone" label="电话">
      </el-table-column>
      <el-table-column prop="address" label="地址">
      </el-table-column>
      <el-table-column prop="remark" label="备注">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button v-if="scope.row.isDelete==true&&roles.indexOf('2')>-1" size="small" type="text" @click="recover(scope.row)" style="color:red">恢复</el-button>
          <template v-else>
            <el-button size="small" type="text" @click="showEdit(scope.row)" v-if="roles.indexOf('3')>-1">编辑</el-button>
            <el-button type="text" size="small" @click="doDelete(scope.row)" v-if="roles.indexOf('2')>-1">禁用</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="60px" ref="editForm" @submit.native.prevent>
        <el-form-item label="客户" prop="name">
          <el-input v-model="editForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone" required>
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address" required>
          <el-input v-model="editForm.address"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="doEdit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!-- 新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="60px" ref="addForm" @submit.native.prevent>
        <el-form-item label="客户" prop="name" required>
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone" required>
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address" required>
          <el-input v-model="addForm.address"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click="doAdd" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template> 

<script>
export default {
  data: function() {
    return {
      postApi: {
        crud: "",
        info: {}
      },

      page: 1, //分页显示信息
      total: 0,
      pageSize: 10,
      infos: [],
      pageSizes: [10, 20, 30, 40],

      name: "", //查询数据
      message: {
        result: {
          infos: []
        }
      },

      addFormVisible: false, //显示新增界面
      addLoading: false,
      addForm: {
        name: "",
        phone: "",
        address: "",
        remark: ""
      },

      editFormVisible: false, //显示编辑界面
      editLoading: false,
      editForm: {
        name: "",
        phone: "",
        address: "",
        remark: ""
      }
    };
  },
  created: function() {
    this.doSelect();
  },
  methods: {
    //新增
    doAdd: async function() {
      if (this.addForm.name === "" || this.addForm.phone === "") {
        this.$message.error("客户和电话不能为空");
      } else {
        this.$confirm("确认提交吗？", "提示", {}).then(async () => {
          this.postApi.crud = "c";
          this.postApi.info = this.addForm;
          this.addLoading = true;
          let res = await this.$doPost("/api/basedata/customer", this.postApi);
          this.addLoading = false;
          if (res.msgCode === 0) {
            this.$message({
              message: "添加成功!",
              type: "success"
            });
            this.name = "";
            this.doSelect();
            this.addForm.name = this.addForm.phone = this.addForm.address = this.addForm.remark =
              "";
          } else {
            this.$message.error({
              message: res.msg
            });
          }
          this.addFormVisible = false;
        });
      }
    },
    //编辑
    showEdit: function(row) {
      this.editFormVisible = true;
      this.editForm.name = row.name;
      this.editForm.phone = row.phone;
      this.editForm.address = row.address;
      this.editForm.remark = row.remark;
    },
    doEdit: function() {
      if (this.editForm.phone === "") {
        this.$message.error("电话不能为空");
      } else {
        this.$confirm("确认提交吗？", "提示", {}).then(async () => {
          this.postApi.crud = "u";
          this.postApi.info = {
            key: this.editForm.name,
            name: this.editForm.name,
            phone: this.editForm.phone,
            address: this.editForm.address,
            remark: this.editForm.remark
          };
          this.editLoading = true;
          let res = await this.$doPost("/api/basedata/customer", this.postApi);
          this.editLoading = false;
          if (res.msgCode === 0) {
            this.$message({
              message: "修改成功!",
              type: "success"
            });
            this.name = "";
            this.doSelect();
            this.editForm.name = this.editForm.phone = this.editForm.address = this.editForm.remark =
              "";
          } else {
            this.$message.error(res.msg);
          }
          this.editFormVisible = false;
        });
      }
    },
    //查询
    doSelect: async function() {
      this.postApi.crud = "r";
      this.postApi.info = {
        name: this.name
      };
      this.listLoading = true;
      this.message = await this.$doPost("/api/basedata/customer", this.postApi);
      // console.log(this.message.result)
      if (this.message.msgCode == 0) {
        this.total = this.message.result.infos.length;
        this.getPageInfo();
      } else {
        this.$message.error(this.message.msg);
      }
      this.listLoading = false;
    },
    //禁用
    doDelete: function(row) {
      this.$confirm(
        "是否禁用 " + row.name + " ?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          this.postApi.crud = "d";
          this.postApi.info = {
            key: row.name
          };
          let res = await this.$doPost("/api/basedata/customer", this.postApi);
          if (res.msgCode === 0) {
            this.$message({
              type: "success",
              message: "禁用成功"
            });
            this.name = "";
            this.doSelect();
          } else {
            this.$message.error("禁用失败");
          }
        })
        .catch(() => {
          this.$message.error("禁用失败");
        });
    },
    //恢复
    recover: function(row) {
      this.$confirm(
        "是否恢复" + row.name,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          this.postApi.crud = "dd";
          this.postApi.info = {
            key: row.name
          };
          let res = await this.$doPost("/api/basedata/customer", this.postApi);
          if (res.msgCode === 0) {
            this.$message({
              type: "success",
              message: "恢复成功"
            });
            this.name = "";
            this.doSelect();
          } else {
            this.$message.error("恢复失败");
          }
        })
        .catch(() => {
          this.$message.error("恢复失败");
        });
    },
    //分页
    handleCurrentChange(val) {
      this.page = val;
      this.getPageInfo();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPageInfo();
    },
    getPageInfo() {
      this.infos = [];
      for (
        let i = this.pageSize * (this.page - 1);
        i < this.pageSize * this.page;
        i++
      ) {
        if (i == this.message.result.infos.length) break;
        this.infos.push(this.message.result.infos[i]);
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/basedata/Customer.vue